<template>
  <div class="vz-individual-order-cargo-card">
    <div class="text-subtitle color-dark vz-individual-order-cargo-card-header">
      <div
        v-if="!editMode"
        :class="{'vz-cursor-pointer hovered-primary': editableName}"
        @click="startEdit"
        class="text-overflow"
      >
        <span>{{ title }}</span>
        <vz-icon
          v-if="editableName"
          name="pencil"
          size="16"
          class="ml-5"
        />
      </div>
      <vz-input
        v-else
        ref="inputRef"
        :model-value="title"
        class="pr-10"
        @update:modelValue="localValue = $event"
        @keydown.enter="onBlur"
        @blur="onBlur"
      />
      <div class="ml-auto flex-shrink-0">
        <vz-close-btn
          v-if="editableName"
          class="vz-close-btn"
          :width='25'
          :height='25'
          title="копировать"
          @click="copy"
        >
          <span class="mdi mdi-content-copy" />
        </vz-close-btn>
        <vz-close-btn
          class="vz-close-btn ml-5"
          :width='25'
          :height='25'
          :class="{disabled}"
          @click="remove"
          title="удалить"
        >
          <span class="mdi mdi-delete" />
        </vz-close-btn>
      </div>
    </div>
    <div class="vz-individual-order-cargo-card-content">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import VzIcon from '~/components/ui-kit/vz-icon.vue'

const emit = defineEmits(['remove', 'copy', 'update:title'])

const props = defineProps({
  title: {
    type: String,
    default: 'Груз'
  },
  disabled: {
    type: Boolean,
    default: false
  },
  editableName: {
    type: Boolean,
    default: true
  }
})

const editMode = ref(false)
const localValue = ref('')
const inputRef = ref()

async function startEdit() {
  if (props.editableName) {
    editMode.value = true
    await nextTick()
    inputRef?.value?.inputControl.focus()
  }
}

function onBlur() {
  editMode.value = false
  emit('update:title', localValue.value)
}

function remove() {
  if (!props.disabled) {
    emit('remove')
  }
}

function copy() {
  emit('copy')
}
</script>

<style lang="scss" scoped>
.vz-individual-order-cargo-card {
  .disabled {
    opacity: 0.5;
  }
}
</style>
